import { Fetch } from 'lib';
import { createRole } from 'services';

type RequestResponses = Awaited<ReturnType<typeof createRole>>;

type RequestParameters = {
  id: string;
};

type RequestBody = Parameters<typeof createRole>[number];

const updateRole = async (params: RequestParameters, body: RequestBody) =>
  await Fetch<RequestResponses, RequestParameters, RequestBody>({
    url: 'adminRole/updateRole',
    method: 'PUT',
    params,
    body,
  });

export { updateRole };
